var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #767676;\n        stroke-miterlimit: 10;\n        stroke-width: .37px;\n      }\n\n      .cls-1, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #b1b1b1;\n        mix-blend-mode: lighten;\n        opacity: .15;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        fill: #272727;\n      }\n\n      .cls-7 {\n        fill: #3b3b3b;\n      }\n\n      .cls-8 {\n        fill: #902df9;\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m124.67,15.2l-.36,2.8-10.59,83.59c-.31,2.44-2.38,4.19-4.64,3.9l-40.31-5.11c-2.26-.29-3.84-2.49-3.53-4.94l10.59-83.59.36-2.8c.26-2.04.72-3.25,1.35-3.94.04-.04.07-.08.11-.11.04-.05.07-.08.12-.11.07-.07.15-.13.23-.18.16-.11.33-.2.51-.26.71-.27,1.54-.2,2.44-.09l8.08,1.02c.05,0,.1.02.15.04.04.01.09.03.13.06.05.03.08.06.12.1.24.24.36.65.3,1.09l-.03.29c-.2,1.55.65,1.67,1.69,1.79l18.68,2.37c.16.02.31.04.46.05.53.04.98.01,1.28-.37.05-.06.09-.13.13-.21.04-.08.08-.17.1-.26.02-.05.03-.1.04-.16.03-.11.05-.24.07-.37l.03-.29c.07-.53.37-.95.74-1.06.09-.03.18-.03.27-.02l8.08,1.02c.94.12,1.79.35,2.42.9.24.21.44.46.61.77.06.1.11.21.15.33.34.84.45,2.03.23,3.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m124.67,15.2l-.36,2.8-10.59,83.59c-.31,2.44-2.38,4.19-4.64,3.9l-40.31-5.11c-2.26-.29-3.84-2.49-3.53-4.94l10.59-83.59.36-2.8c.26-2.04.72-3.25,1.35-3.94.04-.04.07-.08.11-.11.04-.05.07-.08.12-.11.07-.07.15-.13.23-.18.16-.11.33-.2.51-.26.71-.27,1.54-.2,2.44-.09l8.08,1.02c.05,0,.1.02.15.04.04.01.09.03.13.06.05.03.08.06.12.1.24.24.36.65.3,1.09l-.03.29c-.2,1.55.65,1.67,1.69,1.79l18.68,2.37c.16.02.31.04.46.05.53.04.98.01,1.28-.37.05-.06.09-.13.13-.21.04-.08.08-.17.1-.26.02-.05.03-.1.04-.16.03-.11.05-.24.07-.37l.03-.29c.07-.53.37-.95.74-1.06.09-.03.18-.03.27-.02l8.08,1.02c.94.12,1.79.35,2.42.9.24.21.44.46.61.77.06.1.11.21.15.33.34.84.45,2.03.23,3.73Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124,6.83L78.93,1.11c-2.54-.3-4.85,1.52-5.15,4.07,0,0,0,0,0,0l-11.76,92.77c-.34,2.54,1.43,4.87,3.97,5.22l45.07,5.71c2.54.3,4.85-1.52,5.15-4.07l11.76-92.77c.34-2.54-1.44-4.88-3.98-5.22Zm-10.27,94.77c-.31,2.44-2.39,4.19-4.64,3.9l-40.32-5.11c-2.26-.29-3.84-2.49-3.53-4.94l10.95-86.39c.63-4.97,2.49-4.99,4.75-4.7l8.08,1.02c.47.06.79.64.7,1.3l-.04.29c-.2,1.55.65,1.66,1.69,1.79l18.68,2.37c1.05.13,1.89.24,2.09-1.31l.04-.29c.08-.66.53-1.15,1.01-1.09l8.07,1.02c2.26.29,4,1.18,3.42,5.73l-10.95,86.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m124.67,15.2l-.36,2.8-10.59,83.59c-.31,2.44-2.38,4.19-4.64,3.9l-40.31-5.11c-2.26-.29-3.84-2.49-3.53-4.94l10.59-83.59.36-2.8c.26-2.04.72-3.25,1.35-3.94.04-.04.07-.08.11-.11.04-.05.07-.08.12-.11.07-.07.15-.13.23-.18.16-.11.33-.2.51-.26.71-.27,1.54-.2,2.44-.09l8.08,1.02c.05,0,.1.02.15.04.04.01.09.03.13.06.05.03.08.06.12.1.24.24.36.65.3,1.09l-.03.29c-.2,1.55.65,1.67,1.69,1.79l18.68,2.37c.16.02.31.04.46.05.53.04.98.01,1.28-.37.05-.06.09-.13.13-.21.04-.08.08-.17.1-.26.02-.05.03-.1.04-.16.03-.11.05-.24.07-.37l.03-.29c.07-.53.37-.95.74-1.06.09-.03.18-.03.27-.02l8.08,1.02c.94.12,1.79.35,2.42.9.24.21.44.46.61.77.06.1.11.21.15.33.34.84.45,2.03.23,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m103.5,8.34l-5.09-.65c-.17-.02-.3-.18-.27-.35h0c.02-.17.18-.3.35-.27l5.09.65c.17.02.3.18.27.35h0c-.02.17-.18.3-.35.27h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.99.36c-1.14.83-88.92,113.37-88.92,113.37,0,0,28.79-2.46,28.75-2.98S157.1-1.57,157.1-1.57l-25.12,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.62-14.97c-1.14.83-88.92,113.37-88.92,113.37,0,0,14.72-1.9,14.67-2.42S133.66-16.33,133.66-16.33l-11.04,1.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m90.08,28.11l4.32-.03s-2.94,2.56-2.7,2.5,16.09,13.06,16.09,13.06c0,0-15.37-8.27-15.55-8.23s-5.11,6.97-5.11,6.97c0,0-.48-4.59-.68-4.6s-8.26,1.31-8.26,1.31l6.7-8.5-9.28-4.67,9.81,1.11-1.47-6.83,3.06,2.63,2.52-3.48.55,8.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m125.44,9.08l-7.53,3.3-.24-9.35s5.13-4.81,5.53-4.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "94.4 28.08 107.61 14.44 113.64 15.7 117.91 12.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m102.07,20.16s13.3,4.22,13.3,4.22l4.36-4.56,9.93.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.54 19.35 99.55 14.24 94.15 5.13 95.21 .33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "103.73 -1.21 102.57 6.82 97.52 10.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.29 3.51 80.97 8.72 78.96 13.53 83.96 20.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59,24.49c.24-.06,10.38-4.63,10.38-4.63l6.24,6.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.61,85.74l9.37-10.1-2.54-10.44,5.62-3.02-3.29-3.83s-14.79,2.96-15.42,3.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "87.13 42.38 91.88 59.66 87.06 62.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "81.56 78.25 85.45 93.56 83.16 108.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.79,43.64l12.19,5.14s.56,2.4,1.2,5.07c.81,3.39,1.73,7.21,1.78,7.15.15-.18,18.95,13.87,18.95,13.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "138.61 57.2 130.6 57.16 125.89 52.71 121.24 54.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m129.01,65.32s4.68,16.02,4.99,16.26,11.22,7.95,11.22,7.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.64,
    y1: 84.87,
    x2: 138.75,
    y2: 94.53
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent22);
export default __webpack_public_path__ + "static/media/event2-2.15dc335a72dba07917f40d3a362dd630.svg";
export { ForwardRef as ReactComponent };